import Vue from 'vue'
import injector from 'vue-inject'
import store from '../store'

const api = injector.get('api')

class FtoAccounts {
    fetchData() {
        if (store.getters.checkAuth) {
            Vue.http.get(api.user.ftoAccounts).then(response => {
                store.commit('setFtoAccounts', response.body.data)
            })
        }
    }
}

injector.service('ftoAccounts', FtoAccounts)


// WEBPACK FOOTER //
// ./src/services/ftoAccounts.js